import {
    useState,
    useCallback,
} from "react";
import { withNamespaces } from "react-i18next";
import { Row, Col, Button, Container } from "reactstrap";
import DateUtils from "../../../../../../services/utils/DateUtils";
import DataProtectionPorcessingDirectoryService from "../../../../apis/ProcessingDirectoryService";
import { useQuery } from "@tanstack/react-query";
import ViewProcessingDirectoryModal from "../modal/view";
import StringUtils from "../../../../../../services/utils/StringUtils";
import { toast } from "react-toastify";
import "./Style.css";
import BootstrapTable from "react-bootstrap-table-next";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { EMPTY_LIST, INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";
import Spinner from "react-bootstrap/Spinner";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Navigator from "src/modules/data-protection/components/navigator";
import { Link } from "react-router-dom";
import { generateLogDescription } from "src/modules/data-protection/helpers/common";
import FilteringComponent from "./components/filtering-component";
import ExportExcelButton from "./components/export-button";

const DataProtectionProcessingDirectoryList = (props) => {
    const [tableFilters, setTableFilters] = useState({
        pageIndex: 1,
        pageSize: 25,
        fromDate: null,
        toDate: null,
        user: null,
        section: null,
        action: null,
    });

    const dateUtils = new DateUtils();
    const stringUtils = new StringUtils();
    const { t } = props;
    const [selectedActivity, setSelectedActivity] = useState(undefined);
    const [modal, setModal] = useState(false);

    const tableColumns = [
        {
            dataField: "secondary_id",
            text: "#",
            style     :   {
                width : '60px'
            },
            formatter: (cellContent, row) => {
                if (row?.metadata.software_id) {
                    return (
                        <Link
                            className="text-dark"
                            to={`softwares/${row?.metadata.software_id}?tab=processing-activity`}

                        >
                            {cellContent}
                        </Link>
                    );
                }
                else {
                    return (
                        <p
                            className="text-truncate text-capitalize text-left"
                            style={{ cursor: "pointer" }}
                            onClick={() => onViewClick(row)}
                        >
                            {cellContent}
                        </p>)
                }

            },
        },
        {
            dataField: "activityTitle",
            text: t("Activity Title"),
            style: {
                width: '120px',
            },
            sort: true,
            formatter: (_cellContent, { metadata }) => {
                return (
                    <div>
                        <span className="subItem">
                            {t(metadata?.module_name)}
                        </span>
                    </div>
                );
            },
        },
        {
            dataField: "softwareName",
            text: t("Asset Name"),
            style: {
                width: '120px',
            },
            sort: true,
            formatter: (_cellContent, { service }) => {
                return (
                    <div>
                        <span className="subItem">

                            {t(stringUtils.capitalizeFirstLetter(service || ''))
                            }
                        </span>
                    </div>
                );
            },
        },
        {
            dataField: "action",
            text: t("Description"),
            style: {
                width: '200px',
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {t(generateLogDescription(t, row?.action, row?.section, row?.assetType))}
                    </div>
                );
            },
        },
        {
            dataField: "owner",
            text: t("Assigned Analyst"),
            style: {
                width: '200px',
            },
            sort: true,
            formatter: (_cellContent, { software_owner }) => {
                if (!software_owner || Array.isArray(software_owner)) return null;
                if (software_owner?.avatar && software_owner?.avatar !== "") {
                    return (
                        <div className="d-flex gap-1 align-items-center">
                            <div className="avatar-xs ">
                                <span
                                    className="avatar-title bg-soft-primary text-primary rounded-circle text-capitalize"
                                    style={{ overflow: "hidden" }}
                                >
                                    <img
                                        alt={software_owner?.first_name}
                                        src={software_owner?.avatar}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            display: "block",
                                            objectFit: "cover",
                                        }}
                                    />
                                </span>
                            </div>{" "}
                            {`${software_owner?.first_name} ${software_owner?.last_name}`}
                        </div>
                    );
                }
                return (
                    <div>
                        <span className="dt-list-col-bullet me-2">{software_owner[0]}</span>
                        {""}
                        {`${software_owner}`}
                    </div>
                );
            },
        },
        {
            dataField: "responsiblePerson",
            text: t("Responsible Person"),
            style: {
                width: '200px',
            },
            sort: true,
            formatter: (_cellContent, { metadata }) => {
                return metadata?.module_responsible_person
            }
        },
        {
            dataField: "createdAt",
            text: t("Date and Time"),
            sort: true,
            style: {
                width: '120px',
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.created_at
                            ? dateUtils.convertDateToDate(
                                row?.created_at,
                                INTERNATIONAL_DATE_TIME_FORMAT
                            )
                            : null}
                    </div>
                );
            },
        },
        {
            dataField: "",
            text: t("Action"),
            style: {
                width: '120px',
            },
            formatter: (cellContent, row) => {
                return (
                    <div className="actions">
                        <Button
                            color="primary"
                            onClick={() => onViewClick(row)}
                            outline
                            className="border-0"
                        >
                            <i className="ri-eye-line"></i>
                        </Button>
                    </div>
                );
            },
        },
    ];

    const processingActivitiesQuery = useQuery({
        queryKey: [
            "gdpr-fetch-processing-activities-list", 
            tableFilters
        ],
        queryFn: async () => {
            const service = DataProtectionPorcessingDirectoryService.getInstance();
            const response = await service.list(tableFilters);
            return response.data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError(error) {
            if (process.env.NODE_ENV === "development") console.error(error);
            toast(t("Error while fetching processing activities."), {
                type: "error",
            });
        },
    });

    const onViewClick = useCallback((activity) => {
        setSelectedActivity(activity);
        setModal(true);
    }, []);

    const NoDataIndication = () =>
        processingActivitiesQuery.isFetched &&
            !processingActivitiesQuery?.data?.data.length ? (
            <div className="alert m-0" role="alert">
                <p
                    style={{
                        textAlign: "center",
                        marginBottom: 0,
                    }}
                >
                    {t(EMPTY_LIST)}
                </p>
            </div>
        ) : (
            <></>
        );

    const handleTableChange = (type, data) => {
        switch (type) {
            case "pagination":
                const { page, sizePerPage } = data;
                setTableFilters({
                    ...tableFilters,
                    pageIndex: page,
                    pageSize: sizePerPage,
                });
                break;

            case "sort": {
                const { sortField, sortOrder } = data;
                setTableFilters({
                    ...tableFilters,
                    sortField,
                    sortOrder,
                });
                break;
            }
            default:
                return false;
        }
    };

    const handleFilterChange = useCallback((newFilters) => {
        setTableFilters((currentFilters) => ({...currentFilters, ...newFilters}))
    }, []);

    return (
        <div className="page-content ">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            backButtonOptions={() => {
                                return {
                                    title: props.t("Back"),
                                    icon: <i className="ri-arrow-left-fill"></i>,
                                };
                            }}
                            breadCrumbs={[
                                { title: "SIP", link: "/admin/data-protection/dashboard" },
                                {
                                    title: "Processing Directory",
                                    link: `/admin/data-protection/processing-directory`,
                                },
                            ]}
                        />
                    </Col>

                    <Col lg="12" className="mb-4">
                        <div
                            className="bg-white"
                            style={{
                                borderRadius: "7px",
                                boxShadow: "0px 0px 4px 0px #4F666E40",
                                marginBottom: "40px",
                            }}
                        >
                            <div className="p-4" style={{ marginBottom: "300px" }}>
                                <ViewProcessingDirectoryModal
                                    t={t}
                                    modal={modal}
                                    setModal={setModal}
                                    activity={selectedActivity}
                                />

                                <PaginationProvider
                                    pagination={paginationFactory({
                                        custom: true,
                                        page: tableFilters.pageIndex,
                                        sizePerPage: tableFilters.pageSize,
                                        totalSize: processingActivitiesQuery?.data?.itemsCount || 0,
                                        withFirstAndLast: false,
                                        alwaysShowAllBtns: true,
                                        prePageText: (
                                            <span>
                                                <i className="ri-arrow-left-s-line"></i> {t("Back")}
                                            </span>
                                        ),
                                        nextPageText: (
                                            <span>
                                                {t("Next")} <i className="ri-arrow-right-s-line"></i>
                                            </span>
                                        ),
                                        prePageTitle: t("Pre page"),
                                        firstPageTitle: t("Next page"),
                                        showTotal: true,
                                        hideSizePerPage: false,
                                        sizePerPageList: [
                                            {
                                                text: "25",
                                                value: 25,
                                            },
                                            {
                                                text: "50",
                                                value: 50,
                                            },
                                        ],
                                    })}
                                >
                                    {({ paginationProps, paginationTableProps }) => {

                                        return (
                                            <>
                                                <Row className="mb-5 mt-3">
                                                    <Col sm="12">
                                                        <div className="d-flex justify-content-end">
                                                            <FilteringComponent 
                                                                onChange={handleFilterChange}
                                                            />
                                                            <ExportExcelButton />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm="12">
                                                        <BootstrapTable
                                                            remote={{
                                                                pagination: true,
                                                                filter: false,
                                                                sort: true,
                                                                cellEdit: false,
                                                                search: false,
                                                            }}
                                                            loading={
                                                                processingActivitiesQuery.isFetching ||
                                                                processingActivitiesQuery.isLoading
                                                            }
                                                            overlay={overlayFactory({
                                                                spinner: (
                                                                    <Spinner
                                                                        animation="border"
                                                                        variant="primary"
                                                                        size="md"
                                                                    />
                                                                ),
                                                                text: "Loading...",
                                                            })}
                                                            onTableChange={handleTableChange}
                                                            defaultSorted={[]}
                                                            keyField={"id"}
                                                            responsive={true}
                                                            bordered={false}
                                                            data={processingActivitiesQuery?.data?.data || []}
                                                            striped={true}
                                                            columns={tableColumns}
                                                            wrapperClasses="table-responsive"
                                                            classes={"table tpdd-table incident-table"}
                                                            headerWrapperClasses={"thead-light"}
                                                            noDataIndication={() => <NoDataIndication />}
                                                            {...paginationTableProps}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm="12" md="6">
                                                        <div className="tpdd-pagination-style-1">
                                                            <PaginationListStandalone {...paginationProps} />

                                                            <SizePerPageDropdownStandalone
                                                                {...paginationProps}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }}
                                </PaginationProvider>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        token,
    };
};
export default withNamespaces()(
    withRouter(connect(mapStatetoProps)(DataProtectionProcessingDirectoryList))
);
